import type { Doc } from "building-types/doc";
import type { StairSystemHandle } from "building-types/handles/docEntityHandleTypes";
import { DocEntityNodeBase, type DocEntityNodeSource } from "../docEntityNodeBase";
import type { DocEntityReference } from "../docEntityReferenceTypes";

/**
 * StairSystem.stairSettingId's schema declares both the legacy settings-embedded
 * STAIR_CATALOG_SETTINGS catalog container and the new doc-table STAIR_SETTING type (BDG-2943).
 * STAIR_CATALOG_SETTINGS isn't itself a DocEntityType. It resolves through the generic
 * CATALOG_ITEM handle. So the schema-derived reference for it is relabeled here before it ever
 * reaches the generic FK reference validator (docEntityNodeSchemaUtils.ts), or it gets silently
 * dropped there as an unrecognized candidate type.
 *
 * This can be removed once the legacy settings-embedded catalog is fully migrated.
 */
export class StairSystemDocEntityNode extends DocEntityNodeBase<"STAIR_SYSTEM"> {
  constructor(handle: StairSystemHandle, doc: Doc, docEntityNodeSource: DocEntityNodeSource) {
    super(handle, doc, docEntityNodeSource);
  }

  getForeignKeyReferences(): DocEntityReference[] {
    return super.getForeignKeyReferences().map((ref) => {
      if (ref.fieldPath !== "stairSettingId" || (ref.referencedEntityType as string) !== "STAIR_CATALOG_SETTINGS") {
        return ref;
      }
      return { ...ref, referencedEntityType: "CATALOG_ITEM" };
    });
  }
}
